import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCompaniesUiStore = defineStore('insights-companies-ui', () => {
  const searchTerm = ref<string | null>(null)
  const didAutoSortOnFilterError = ref(false)

  function setSearchTerm(value: string | null): void {
    searchTerm.value = value
  }

  function reset(): void {
    didAutoSortOnFilterError.value = false
  }

  return {
    searchTerm,
    didAutoSortOnFilterError,
    setSearchTerm,
    reset,
  }
})
